import type { VoidFunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import ModalDeleteDependency from '../../dependencies/ModalDeleteDependency';
import type { ModalProps } from '.';
import * as DependenciesV2Store from '../../../../redux/dependenciesV2';
import { queryClient } from '../../../../ReactQuery';

type Props = ModalProps & {
  onProjectChange: () => void;
};

const DeleteDependency: VoidFunctionComponent<Props> = ({ projectRevision, modals, onProjectChange }) => {
  const dispatch = useDispatch();
  const { isOpen, onClose } = modals.deleteDependencyModal;
  const { revision, title, isManual } = modals.deleteDependencyModal.context;

  if (!revision || !title) {
    return null;
  }

  const removeDepFromBuildWatch = () => {
    //  Tell React Query to refetch the revision, if it's been fetched.
    //  This is done to update the counts in the subnav
    queryClient.invalidateQueries(['revisions', projectRevision]);
    return dispatch(DependenciesV2Store.actions.removeRevisionFromBuildWatch(revision));
  };

  return (
    <ModalDeleteDependency
      parent_locator={projectRevision}
      revision={{
        locator: revision,
        project: {
          title,
        },
        manual: isManual,
      }}
      onIgnoreDependency={removeDepFromBuildWatch}
      onDeleteDependency={removeDepFromBuildWatch}
      onProjectChange={onProjectChange}
      show={isOpen}
      onHide={onClose}
  />
  );
};

export default DeleteDependency;
